import React, { useEffect } from 'react';
import { hooks, constants } from '@lifesize/clients.sdk';
import Header from 'containers/InCall/InCallHeader/InCallHeaderContainer';
import Footer from 'containers/InCall/InCallFooter/InCallFooterContainer';
import NotificationPillContainer from 'containers/NotificationPill/NotificationPillContainer';
import classes from './CallViewHolder.module.scss';
import { CallLayout, AudioStream } from '@lifesize/clients.sdk';
import { useSelector } from 'react-redux';
import { setAudioOutput } from 'utils/deviceUtils';
import { getMaximumReceiveStreams } from 'utils/mediaConstraints';

/**
 * Top level call holder view. Simply contains the Header, Video, and Footer
 * elements.
 */
let observer;

export const CallViewHolder = (props) => {
  const call = hooks.useCallState();
  const callDisconnected = call && call.state === constants.CALL_STATE_DISCONNECTED;
  const audioOnlyStreams = hooks.useRemoteStreamsAudioOnly();
  const media = hooks.useMedia();
  // TODO: PT: this should be moved into the call layout component. TODO before SFU multistream GA release.
  const { sfuSettings } = hooks.useAccountSettings();
  const showToggle = getMaximumReceiveStreams() > 1 && !!sfuSettings?.sfuMultiStream;
  const { isWebConferencing, speakers } = useSelector((state) => {
    const isWebConferencing = state.app.call?.isWebConference;
    const speakers = state.app.mediaSettings?.speakers;

    return {
      isWebConferencing,
      speakers
    };
  });

  useEffect(() => {
    if (speakers && Object.keys(media.remoteStreams).length) {
      setAudioOutput(speakers);
    }
  }, [media.remoteStreams, speakers]);

  useEffect(() => {
    window.addEventListener('beforeunload', props.webappCloseWhiteboard);

    const getDiv = () => document.getElementById('callLayout-holder-div');
    // set viewport width for layouts
    // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    const setVw = () => {
      const vw = (getDiv() ? getDiv().offsetWidth : window.innerWidth) * 0.01;
      document.documentElement.style.setProperty('--vw', `${vw}px`);
    };

    if (getDiv()) {
      observer = new window.BackupResizeObserver(setVw);
      observer.observe(getDiv());
    }
    setVw();
    return () => {
      window.removeEventListener('beforeunload', props.webappCloseWhiteboard);
      // close the whiteboard if the call ends
      if (callDisconnected) props.webappCloseWhiteboard();
      if (getDiv()) {
        observer.unobserve(getDiv());
      }
      observer = null;
    };
  }, [callDisconnected, props]);

  return (
    <div className={classes.container}>
      <Header />
      <div id="callLayout-holder-div" className={classes.layoutContainer}>
        <CallLayout muteRemotes={isWebConferencing} showToggle={showToggle} />
      </div>
      {audioOnlyStreams.map((s, i) => (
        <AudioStream id={`audio-only-${i}`} mediaStream={s.stream} />
      ))}
      <NotificationPillContainer inCall />
      <Footer />
    </div>
  );
};

export default CallViewHolder;
